import './DetectedAppNotice.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { getQueryString } from '@sonar-software/sonar-http';
import { Link } from 'react-router-dom';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { SonarText } from '@ui/text';
import { Space } from 'antd';
import { COPY_SPECIFIC, DATA_SECURITY_DASHBOARD, FULL_ROUTES, LINKS, ORGANIZATION_TYPE_LABELS } from '@sonar-software/sonar-ts-constants';
import { Else, If, Then } from 'react-if';
import { FullUserBoundary, SanitizedHtml } from '@ui/general';
import { useApplicationReference, useAsyncStateWithPreload, useCurrentOrganizationSubdomain } from '@hooks';
function withColon(value) {
    return `${value}:`;
}
const getDataSecurityActionPlanSelector = createAsyncSelectors((state) => state.core.dataSecurity.actionPlan.get);
export const DetectedAppNotice = ({ applicationId }) => {
    const { name } = useApplicationReference(applicationId);
    const subdomain = useCurrentOrganizationSubdomain();
    const { data, isRequested } = useAsyncStateWithPreload(getDataSecurityActionPlanSelector, coreActions.requestGetCoreDataSecurityActionPlan, true, { applicationId });
    if (isRequested) {
        React.createElement(LoadingSpinner, { spinning: isRequested });
    }
    return (React.createElement(If, { condition: Boolean(data === null || data === void 0 ? void 0 : data.text) },
        React.createElement(Then, null, data && React.createElement(SanitizedHtml, { html: data.text })),
        React.createElement(Else, null,
            React.createElement("div", { className: 'detected-app-notice' },
                React.createElement(Space, { direction: 'vertical', size: 'small' },
                    React.createElement("div", { className: 'h3' }, DATA_SECURITY_DASHBOARD.SUGGESTED_ACTION_PLAN_DETECTED_APP),
                    React.createElement(SonarText, null, DATA_SECURITY_DASHBOARD.DETECTED_APP_ACCESS_CHANGES(name))),
                React.createElement("div", { className: 'sub-header' }, withColon(DATA_SECURITY_DASHBOARD.PERMISSION_AND_ACCESS_CONTROL)),
                React.createElement("ul", null,
                    React.createElement("li", null,
                        DATA_SECURITY_DASHBOARD.ACCESS_PERMISSIONS,
                        React.createElement("a", { href: LINKS.SALESFORCE_MANAGE_USERS(subdomain), target: '_blank' }, ORGANIZATION_TYPE_LABELS.SALESFORCE)),
                    React.createElement("li", null,
                        DATA_SECURITY_DASHBOARD.REVIEW_FIELD_LEVEL_SECURITY,
                        React.createElement("a", { href: LINKS.SALESFORCE_MANAGE_OBJECTS(subdomain), target: '_blank' }, COPY_SPECIFIC.SALESFORCE_OBJECT_MANAGER))),
                React.createElement("div", { className: 'sub-header' }, withColon(DATA_SECURITY_DASHBOARD.SECURITY_AND_COMPLIANCE_REVIEW)),
                React.createElement("ul", null,
                    React.createElement("li", null, DATA_SECURITY_DASHBOARD.AUDIT_TRAIL),
                    React.createElement("li", null, DATA_SECURITY_DASHBOARD.DATA_SECURITY_POLICIES),
                    React.createElement("li", null, DATA_SECURITY_DASHBOARD.THIRD_PARTY_ASSESSMENT(name))),
                React.createElement(FullUserBoundary, null,
                    React.createElement("div", { className: 'sub-header' }, withColon(DATA_SECURITY_DASHBOARD.MONITORING_AND_INCIDENT_MANAGEMENT)),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement(Link, { to: `${FULL_ROUTES.ADD_APP}?${getQueryString({ applicationId })}` }, withColon(DATA_SECURITY_DASHBOARD.MONITOR_APP(name))),
                            " ",
                            DATA_SECURITY_DASHBOARD.ADD_TO_MONITOR)))))));
};
